import React from 'react'

import styles from './PageTitle.module.scss'

interface PageTitleProps {
    title: string
}

function PageTitle({ title }: PageTitleProps) {
  return (
    <h4 className={styles.baseTitle}>{title}</h4>
  )
}

export default PageTitle